import { isAfter, addYears } from "date-fns";

/**
 * 数组去重
 * @param {Array} arr
 * @returns {Array}
 */
export const unique = (arr) => {
  return Array.from(new Set(arr));
};
// 高亮替换
export const highlightKeyword = (text, keyword) => {
  text = text || "";
  var re = new RegExp(keyword, "g");
  return keyword ? text?.replace(re, `<span style="color:#FAAE56">${keyword}</span>`) : text;
};

// 是否大于15岁
export const isOver15 = (birthday) => {
  return isAfter(new Date(), addYears(new Date(birthday), 15));
};

// 等级选择查询
export const calcLevelActive = (levelList, levelActiveId) => {
  let levelType = "";
  let levelId = "";
  let levelIndex = "";

  if (levelActiveId) {
    const findLevel = levelList?.find((item) => {
      const findActiveLevel = item?.levels?.find((item1) => {
        return item1?.id == levelActiveId;
      });
      if (findActiveLevel) {
        levelId = findActiveLevel?.id;
        levelIndex = findActiveLevel?.level_id;
      }

      return !!findActiveLevel;
    });
    if (findLevel) {
      levelType = findLevel?.level_type;
    }
  } else {
    levelType = levelList?.[0]?.level_type;
    levelId = levelList?.[0]?.levels?.[0]?.id;
    levelIndex = levelList?.[0]?.levels?.[0]?.level_id;
  }

  return {
    levelType,
    levelId,
    levelIndex,
  };
};
